import type { WebsitePageKind } from '../../types/website-templates';
import { WEBSITE_PAGE_KINDS } from '../../types/website-templates';

/**
 * A3 store-owned routes. Patterns are React Router path patterns in both the
 * slug form (`/s/:slug/...`) and the tenant-host form.
 */
export const STORE_OWNED_ROUTE_PAGE_KIND: Readonly<Record<string, WebsitePageKind>> = {
  '/s/:slug': 'home',
  '/s/:slug/categories': 'catalog',
  '/s/:slug/shop': 'catalog',
  '/s/:slug/c/:categoryId': 'catalog',
  '/s/:slug/collections/:collectionKey': 'catalog',
  '/s/:slug/collections/custom/:collectionRef': 'catalog',
  '/s/:slug/sales': 'catalog',
  '/s/:slug/offers/:campaignSlug': 'catalog',
  '/s/:slug/p/:productId': 'product',
  '/s/:slug/cart': 'cart',
  '/s/:slug/checkout': 'checkout',
  '/s/:slug/about': 'store-info',
  '/categories': 'catalog',
  '/shop': 'catalog',
  '/c/:categoryId': 'catalog',
  '/collections/:collectionKey': 'catalog',
  '/collections/custom/:collectionRef': 'catalog',
  '/sales': 'catalog',
  '/offers/:campaignSlug': 'catalog',
  '/p/:productId': 'product',
  '/cart': 'cart',
  '/checkout': 'checkout',
  '/about': 'store-info',
  /** Store-owned only when the order row resolves a store (server-side). */
  '/account/orders/:orderId': 'order',
};

/** Marketplace-owned routes: Dukanti theme and marketplace language. */
export const marketplaceOwnedRoutes = [
  '/',
  '/account',
  '/account/profile',
  '/account/addresses',
  '/account/orders',
  '/account/signin',
  '/account/forgot-password',
  '/account/reset-password',
  '/auth/callback',
] as const;

export function isStoreOwnedRoute(routePattern: string): boolean {
  return Object.prototype.hasOwnProperty.call(STORE_OWNED_ROUTE_PAGE_KIND, routePattern);
}

export function pageKindForRoute(routePattern: string): WebsitePageKind | null {
  return isStoreOwnedRoute(routePattern)
    ? (STORE_OWNED_ROUTE_PAGE_KIND[routePattern] ?? null)
    : null;
}

export function isWebsitePageKind(value: unknown): value is WebsitePageKind {
  return typeof value === 'string' && (WEBSITE_PAGE_KINDS as readonly string[]).includes(value);
}

/** First slot-id segment for a page kind (`store-info` → `storeInfo`). */
export function slotScopeForPageKind(pageKind: WebsitePageKind): string {
  return pageKind === 'store-info' ? 'storeInfo' : pageKind;
}

export const WEBSITE_CHROME_SLOT_SCOPE = 'chrome';
